import React from 'react';
import { Typography } from '@mui/material';
import { red, green } from '@mui/material/colors';
import { droneDeliveryDurationMinutes } from '../../../utils/date-utils';

interface HeaderTimerProps {
  expectedDeliveryDate?: string;
}

const HeaderTimer = ({ expectedDeliveryDate }: HeaderTimerProps) => {
  const [now, setNow] = React.useState<number>(Date.now());

  React.useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!expectedDeliveryDate) return null;

  try {
    const oneMinInMs = 60000;
    const droneMs = (droneDeliveryDurationMinutes || 0) * 60 * 1000;
    const takeoffTime = new Date(expectedDeliveryDate).getTime() - droneMs;
    const isOverDue = takeoffTime < now;
    
    let mins: number;
    let color: string;
    
    if (isOverDue) {
      // After takeoff - count up (overdue)
      const delta = now - takeoffTime;
      mins = Math.floor(delta / oneMinInMs);
      color = red[500];
    } else {
      // Before takeoff - count down
      const delta = takeoffTime - now;
      mins = Math.floor(delta / oneMinInMs);
      color = green[500];
    }

    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 6,
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: '4px 12px'
      }}>
        <div style={{ 
          width: 8, 
          height: 8, 
          borderRadius: '50%', 
          backgroundColor: color 
        }} />
        <Typography variant="body2" style={{ fontSize: 14, color: '#6B7280' }}>
          {isOverDue ? '-' : ''}{mins} mins
        </Typography>
      </div>
    );
  } catch (_e) {
    return null;
  }
};

export default HeaderTimer;
